





























import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { State } from "vuex-class";

import AliasedRequestProgressContainer from "@/components/ui/AliasedRequestProgressContainer.vue";

import { falconComplaintStateFilter } from "@/filters/falcon/falcon-complaint-state.filter";
import { falconComplaintDecisionTypeFilter } from "@/filters/falcon/falcon-complaint-decision-type.filter";
import { capitalizeFilter } from "@/filters/capitalize.filter";

import { GetMyComplaintsComplaintListItem } from "@/interfaces/falcon/get-my-complaints/get-my-complaints-complaint-list-item";

import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaints table component
 */
@Component({
  components: { AliasedRequestProgressContainer },
  filters: {
    ...falconComplaintDecisionTypeFilter,
    ...falconComplaintStateFilter,
    ...capitalizeFilter
  }
})
export default class ComplaintsTable extends Vue {
  @State(state => state.falconComplaints.complaintsData)
  complaintsData!: GetMyComplaintsComplaintListItem[];
  requestAliasEnum = RequestAlias;
  i18nMessageKeyEnum = I18nMessageKey;
}
